import {
  HStack,
  Center,
  Icon,
  Text,
  Circle,
  SquareProps,
  Box,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from '../colors';
import { FiUser } from 'react-icons/fi';

export const UserBadge: React.FC<{
  userName: string;
  organizationName: string;
  iconBackgroundColor?: SquareProps['backgroundColor'];
}> = ({ iconBackgroundColor, userName, organizationName }) => {
  return (
    <HStack
      flexDirection="row"
      width="fit-content"
      textAlign="left"
      justifyContent="space-between"
    >
      <Circle bg={iconBackgroundColor || colors.millet[100]} size="50px">
        <Center>
          <Icon fontSize="25px">
            <FiUser />
          </Icon>
        </Center>
      </Circle>
      <Box>
        <Text fontSize="sm" fontWeight="bold">{`Welcome, ${userName}`}</Text>
        <Text fontSize="sm" colorScheme="gray">
          {organizationName}
        </Text>
      </Box>
    </HStack>
  );
};
